import lastDayOfYear from "date-fns/lastDayOfYear";
import startOfYear from "date-fns/startOfYear";

import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetAllLeads = async (
  Year = "*",
  Filter = "newest",
  lastSnapshot = "*",
  LimitCount = 10
) => {
  /**
   * input: null
   * output: leads object
   * description: fetches All leads
   */

  try {
    let firstDay;
    let lastDay;
    if (Year === "*") {
      firstDay = startOfYear(new Date().setFullYear(2000));
      lastDay = lastDayOfYear(new Date());
    } else {
      firstDay = startOfYear(new Date(Year));
      lastDay = lastDayOfYear(new Date(Year));
    }

    const leadsCollection = collection(db, "leads");
    let q;

    if (Filter === "newest") {
      q = query(
        leadsCollection,
        where("is_deleted", "==", false),
        where("bid", "==", getLocalStorageItem("bid")),
        where("createdAt", ">", firstDay),

        where("createdAt", "<", lastDay),
        orderBy("createdAt", "desc"),

        startAfter(lastSnapshot),
        limit(LimitCount)
      );
    } else if (Filter === "oldest") {
      q = query(
        leadsCollection,
        where("is_deleted", "==", false),
        where("bid", "==", getLocalStorageItem("bid")),
        where("createdAt", ">", firstDay),
        where("createdAt", "<", lastDay),

        orderBy("createdAt"),
        limit(LimitCount)
      );
    }

    const leadsSnapshot = await getDocs(q);

    let leads = [];
    leadsSnapshot.forEach((lead) =>
      leads.push({ id: lead.id, ...lead.data() })
    );

    return {
      leads,
      leadsSnapshot,
    };
  } catch (error) {
    console.log(error);
  }
};

export default GetAllLeads;
